import * as types from "../types/ordersOfOrderPage"

const initialState = {
  orders: [],
  orderHistory: []
}

const ordersOfOrderPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_PAGE_ORDERS:
      return {
        ...state,
        orders: action.newOrders
      }
    case types.UPDATE_PAGE_ORDER:
      return {
        ...state,
        orders:
          state.orders.map(order =>
            order._id === action.orderId
              ?
              {
                ...order,
                ...action.editedOrder
              }
              :
              order
          )
      }
    case types.REMOVE_PAGE_ORDER:
      return {
        ...state,
        orders:
          state.orders.filter(order =>
            order._id !== action.orderId
          )
      }
    case types.UPDATE_PAGE_ORDERS_HISTORY:
      return {
        ...state,
        orderHistory: action.newOrders
      }
    case types.UPDATE_PAGE_ORDER_HISTORY:
      return {
        ...state,
        orderHistory:
          state.orderHistory.map(order =>
            order._id === action.orderId
              ?
              {
                ...order,
                ...action.editedOrder
              }
              :
              order
          )
      }
    case types.REMOVE_ALL_PAGE_ORDERS:
      return {
        orders: [],
        orderHistory: []
      }
    default:
      return state
  }
}

export default ordersOfOrderPageReducer